import { useEffect, useState } from 'react';

const queries = {
  isDesktop: '(min-width: 768px)'
};

const createInitialState = () => {
  if (typeof window === 'undefined') {
    return { isDesktop: false };
  }

  return {
    isDesktop: window.matchMedia(queries.isDesktop).matches
  };
};

function useBreakpoint() {
  const [state, setState] = useState(createInitialState);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const mediaQueryList = window.matchMedia(queries.isDesktop);
    const handler = (event) => {
      setState({ isDesktop: event.matches });
    };

    mediaQueryList.addEventListener('change', handler);
    // Sync state in case effect runs after initial layout has changed.
    setState({ isDesktop: mediaQueryList.matches });

    return () => mediaQueryList.removeEventListener('change', handler);
  }, []);

  return state;
}

export default useBreakpoint;

